import { render, staticRenderFns } from "./MessageLogsTemplates.vue?vue&type=template&id=15645aae&"
import script from "./MessageLogsTemplates.vue?vue&type=script&lang=ts&"
export * from "./MessageLogsTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports